import type { CloudSave } from "../game/cloudSave";
import { apiUrl } from "./apiBase";

export async function pullSave(
  playerId: string,
  appleUserId: string | null,
): Promise<CloudSave | null | undefined> {
  const qs = new URLSearchParams();
  if (playerId) qs.set("playerId", playerId);
  if (appleUserId) qs.set("appleUserId", appleUserId);
  try {
    const r = await fetch(apiUrl(`/api/save?${qs}`), {
      headers: { Accept: "application/json" },
    });
    if (r.status === 404) return null;
    if (!r.ok) return undefined;
    const j = (await r.json()) as { player?: CloudSave };
    return j.player ?? null;
  } catch {
    return undefined;
  }
}

export async function pushSave(save: CloudSave): Promise<CloudSave | null> {
  try {
    const r = await fetch(apiUrl("/api/save"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(save),
    });
    if (!r.ok) return null;
    const j = (await r.json()) as { player?: CloudSave };
    return j.player ?? null;
  } catch {
    return null;
  }
}

export async function verifyIap(opts: {
  transactionId: string;
  productId: string;
  playerId: string;
  appleUserId: string | null;
}): Promise<{
  verified: boolean | null;
  credited?: boolean;
  player?: CloudSave;
} | null> {
  try {
    const r = await fetch(apiUrl("/api/iap/verify"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(opts),
    });
    if (!r.ok) return null;
    return (await r.json()) as {
      verified: boolean | null;
      credited?: boolean;
      player?: CloudSave;
    };
  } catch {
    return null;
  }
}

let pushTimer: ReturnType<typeof setTimeout> | null = null;

export function schedulePush(getSave: () => CloudSave) {
  if (pushTimer) clearTimeout(pushTimer);
  pushTimer = setTimeout(() => {
    pushTimer = null;
    void pushSave(getSave());
  }, 700);
}
